import { Component, OnInit } from '@angular/core';
import { DepositActionRuleDTO } from './deposit-ticker-action.model';
import { DepositTickerRuleService } from './deposit-ticker-rule.service';

@Component({
  selector: 'app-deposit-ticke-action-rules',
  templateUrl: './deposit-ticke-action-rules.component.html',
  styleUrls: ['./deposit-ticke-action-rules.component.scss'],
  standalone: false,
})
export class DepositTickeActionRulesComponent implements OnInit {
  rules: DepositActionRuleDTO[] = [];

  creatingNew = false;

  constructor(private service: DepositTickerRuleService) {}

  ngOnInit(): void {
    this.service.getAll().subscribe((list) => (this.rules = list));
  }

  addRule(): void {
    this.creatingNew = true;
  }

  create(value: DepositActionRuleDTO) {
    this.creatingNew = false;
    this.rules.push(value);
  }

  update($event: DepositActionRuleDTO, index: number) {
    this.rules.splice(index, 1, $event);
  }

  deleteElement(i: number): void {
    this.rules.splice(i, 1);
  }
}
